import { render, staticRenderFns } from "./PanelCompetitionSettingRegister.vue?vue&type=template&id=62576980&scoped=true&"
import script from "./PanelCompetitionSettingRegister.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingRegister.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingRegister.vue?vue&type=style&index=0&id=62576980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62576980",
  null
  
)

export default component.exports